module.exports = __webpack_public_path__ + "img/winning-other.554ba8b2.png";